import { Component } from 'react';

// @probestack/probestack-ui-library's Header/ProfileDropdown has no error
// boundary of its own, so when its background profile fetch to the
// admin-backend fails in a way it doesn't expect (e.g. an expired session
// token), it can throw during render and - with no boundary anywhere in the
// tree - React unmounts the *entire* app, not just the header. This scopes
// that failure to the header strip alone: the rest of the page (sidebar,
// content) keeps working, and a simple fallback bar still shows the logo.
export class HeaderErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Header failed to render (likely an expired session token) — showing fallback bar instead of crashing the app.', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
